module.exports = __webpack_public_path__ + "img/SE5164010190.6fa615b9.png";